




















import { Component, Vue, Prop } from 'vue-property-decorator';
import MaterialItemForm from '@/components/forms/MaterialItemForm.vue';
import { Route, RawLocation } from 'vue-router';
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate'
]);

@Component({
    components: {
        MaterialItemForm
    }
})
export default class ItemEdit extends Vue {
    public $refs!: {
    materialItemForm: MaterialItemForm
  };

    @Prop() public id!: string | number;
    public beforeRouteUpdate(
        to: Route, from: Route, next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void) {
            this.$refs.materialItemForm.updateForm();
            next();
    }
}
